module.exports = __webpack_public_path__ + "img/background.4ef86496.jpg";